import Vue from "vue";

import { retrieveToggles } from "@nuskin/ns-feature-flags";
import { arrayDifference } from "@nuskin/ns-common-lib";

let NsProductFeatureFlagsService = Vue.prototype.$NsProductFeatureFlagsService;
if (!NsProductFeatureFlagsService) {
  const newEl = document.createElement("div");
  newEl.id = "ns-product-feature-flags-service";
  const serviceEl = document.body.appendChild(newEl);

  NsProductFeatureFlagsService = new Vue({
    name: "NsProductFeatureFlagsService",
    data() {
      return {
        featureFlags: {},
        useProductData: false,
        loading: true
      };
    },
    computed: {
      awsUrl() {
        return this.$NsProductAppService.awsUrl;
      },
      userId() {
        return this.$NsProductUserService.userId;
      }
    },
    mounted() {
      this.addListeners();
    },
    destroyed() {
      this.removeListeners();
    },
    methods: {
      /**
       * Set current feature flags
       */
      async setFeatureFlags() {
        if (
          this.$NsProductAppService.loading ||
          this.$NsProductUserService.loading
        ) {
          return;
        }

        this.loading = true;

        const lambdaUrl = `${this.awsUrl}/feature-flags/v1/proxy`;
        const featureToggles = Array.from(
          await retrieveToggles(lambdaUrl, this.userId)
        );

        const previousFeatureFlags = Object.keys(this.featureFlags).filter(
          flag => !!this.featureFlags[flag]
        );

        const featureFlagsDifference = arrayDifference(
          featureToggles,
          previousFeatureFlags
        );

        if (featureFlagsDifference.length) {
          const featureFlags = featureToggles.reduce(
            (featureFlags, flag) => ((featureFlags[flag] = true), featureFlags),
            {}
          );
          this.featureFlags = featureFlags;
          this.useProductData = !!this.featureFlags[
            "cx12-2118-product-data-lambda"
          ];

          // we need to set loading before the emit, but after data is changed
          this.loading = false;
          this.$emit("feature-flags-changed", this.featureFlags);
        } else {
          this.loading = false;
        }
      },

      /**
       * Subscribe to events, should only be called when mounted
       */
      addListeners() {
        // watch app service and user service finished loading
        this.$watch(
          function() {
            return (
              this.$NsProductAppService.loading ||
              this.$NsProductUserService.loading
            );
          },
          () => this.setFeatureFlags(),
          {
            immediate: true
          }
        );

        // WARNING: $NsProductUserService.$on wasn't always working here
        // listen to product user changes
        // this.$NsProductUserService.$on("user-changed", this.setFeatureFlags);
      },

      /**
       * Unsubscribe to events, should only be called when destroyed
       */
      removeListeners() {
        // stop listening to product user changes
        // this.$NsProductUserService.$off();
      }
    }
  }).$mount(serviceEl);

  Vue.prototype.$NsProductFeatureFlagsService = NsProductFeatureFlagsService;
}

export default NsProductFeatureFlagsService;
